import { DISPLAY_TRACKING_USER_HISTORY, UPDATE_TRACKING_USER_HISTORY } from '../../../types/conversations/plugins'

const initialTrackingUserHistory = {
  isOpen: false,
  isLoading: false,
  history: [],
}


export default function trackingUserHistory(state = initialTrackingUserHistory, action) {
  switch (action.type) {
    case DISPLAY_TRACKING_USER_HISTORY: {
      const { isOpen, isLoading } = action
      return Object.assign({}, state, { isOpen, isLoading })
    }
    case UPDATE_TRACKING_USER_HISTORY: {
      const { history } = action
      return Object.assign({}, state, { isLoading: false, history })
    }
    default: {
      return state
    }
  }
}
